{
	"actions": {
		"cancel": "Cancel",
		"copy_link": "Copy link",
		"edit": "Edit link",
		"open_menu": "Open actions",
		"revoke": "Revoke"
	},
	"change_expiry": {
		"out_of_range": "That date is outside what your organization allows.",
		"out_of_range_days_one": "The expiry may be at most {{count}} day from now.",
		"out_of_range_days_other": "The expiry may be at most {{count}} days from now.",
		"refusal": {
			"incomplete": "Finish the date: day, month and year.",
			"invalid": "This day does not exist. Check the day and the month.",
			"required": "A date is needed: pick one to save.",
			"too_early": "This date has already passed. Expiry starts tomorrow."
		}
	},
	"columns": {
		"access_count": "Opens",
		"expiry": "Expires",
		"kind": "Type",
		"password": "Password",
		"resource": "Resource",
		"state": "State"
	},
	"edit": {
		"description": "Link to “{{name}}”. Changes apply immediately.",
		"done": "Link updated.",
		"password": {
			"missing": "Enter a password to protect the link.",
			"required_refusal": "Your organization requires a password on every link, so it cannot be removed."
		},
		"pending": "Saving…",
		"submit": "Save",
		"title": "Edit link"
	},
	"empty": {
		"description": "Create a link from a file or folder's menu to share it outside your organization.",
		"disabled_description": "Your administrator has turned public links off for this organization.",
		"disabled_title": "Links are disabled",
		"no_matches_description": "Try a different filter.",
		"no_matches_title": "No links match this filter",
		"title": "No active links"
	},
	"expiry": {
		"never": "No expiry"
	},
	"filters": {
		"state": "State"
	},
	"kind": {
		"download": "Share",
		"upload": "Upload link"
	},
	"kind_filter": {
		"all": "All",
		"download": "Shares",
		"upload": "Upload links"
	},
	"page_title": "My active links",
	"password": {
		"no": "No password",
		"yes": "Password protected"
	},
	"refusal": {
		"not_found": "This link no longer exists. Refresh the list."
	},
	"revoke": {
		"confirm": "Revoke",
		"description": "The link stops working immediately.",
		"done": "Link revoked.",
		"pending": "Revoking…",
		"title": "Revoke this link?"
	},
	"search_placeholder": "Search by resource",
	"state": {
		"active": "Active",
		"expired": "Expired",
		"policy_blocked": "Blocked by policy",
		"revoked": "Revoked"
	},
	"state_helper": {
		"policy_blocked": "Resumes automatically if your administrator turns links back on."
	},
	"view": {
		"all": "All",
		"expired": "Expired",
		"live": "Active",
		"revoked": "Revoked"
	}
}
